import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { formatDate } from "../../../../util/format"

import { useTokens } from "../../../../hooks/useTokens";

const Overview = () => {
  const { subscriptionType } = useSelector((state) => state.auth.team);
  const { createdAt: userCreateDate, updatedAt: userUpdateDate } = useSelector((state) => state.auth.user);

  const { availableTokens, cvTokensExpiringSoon, earliestExpiryDate } = useTokens({});

  return (
    <>
      <br />
      <span className={classNames("overview")}>
        <FormattedMessage
          id="common.billingOverview.currentPlan"
          values={{
            currentPlan: (
              <span className="overview__overview-color">
                {subscriptionType}
              </span>
            ),
          }}
        />
      </span>
      <br />
      <span className={classNames("text-normal")}>
        <FormattedMessage
          id="common.billingOverview.accountCreationDate"
          values={{
            userCreatedDate: (
              <span className="overview__overview-color">
               {formatDate(userCreateDate)}
              </span>
            ),
          }}
        />
      </span>
      <br />
      <span className={classNames("text-normal")}>
        <FormattedMessage
          id="common.billingOverview.accountUpdateDate"
          values={{
            userUpdateDate: (
              <span className="overview__overview-color">
                {formatDate(userUpdateDate)}
              </span>
            ),
          }}
        />
      </span>
      <br />
      <span className={classNames("text-normal")}>
        <FormattedMessage
          id="common.billingOverview.currentTokens"
          values={{
            tokens: (
              <span className="overview__overview-color">
                {availableTokens}
              </span>
            ),
          }}
        />
      </span>
      <br />
      <span className={classNames("text-normal")}>
        <FormattedMessage
          id="common.billingOverview.creditsExpiringSoon"
          values={{
            tokens: <b>{cvTokensExpiringSoon || 0}</b>,
            earliestExpiryDate: (
              <span className="overview__overview-color">
                {formatDate(earliestExpiryDate)}
              </span>
            ),
          }}
        />
      </span>
    </>
  );
};

export default Overview;